import { Controller } from "@hotwired/stimulus";

/** Toggle password field between password and text; optional show/hide icon targets. */
export default class extends Controller {
  static targets = ["input", "eyeOpen", "eyeClosed"];

  toggle(event) {
    event.preventDefault();
    const input = this.inputTarget;
    const reveal = input.type === "password";
    input.type = reveal ? "text" : "password";

    if (this.hasEyeOpenTarget && this.hasEyeClosedTarget) {
      this.eyeOpenTarget.classList.toggle("hidden", reveal);
      this.eyeClosedTarget.classList.toggle("hidden", !reveal);
    }
  }
}
